<template>
  <div class="wb-sidebar-categories-label">
      <div class="wb-sidebar-categories-label-text">{{text}}</div>
<!--      <div class="wb-c-green-line-h"></div>-->
  </div>
</template>

<script>
export default {
    name: 'SidebarCategoriesLabel',
    props: [
        'text',
    ],
};
</script>

<style scoped lang="scss">
@import "CSS/colors.scss";
@import "CSS/fonts.scss";
@import "CSS/common.scss";

.wb-sidebar-categories-label {
    width: 100%;
    box-sizing: border-box;
    cursor: default;
    user-select: none;
    @include font-hcl;
}

.wb-sidebar-categories-label-text {
    color: $lightBlue;
    padding: 5px 0;
    text-align: center;
    @include wb-c-flex-center-start;
}
</style>
